'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { NarvarEventTypes, useAnalytics } from './useAnalytics';

export function WebVitals({ url }: { url: string }) {
  const { logEvent } = useAnalytics();

  useReportWebVitals(async (metric) => {
    logEvent(url, {
      event_name: metric.id,
      event_type: NarvarEventTypes.WEB_VITAL,
      metric_name: metric.name,
      metric_value_number: +metric.value,
    });
  });

  return null;
}
